import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData,
  type CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError,
  type CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse,
  createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost,
} from '../../generated';

export type CreatePdpImageMutationVariables = CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData['path'] &
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData['body'];

export type CreatePdpImageMutation = CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse;

export const useCreatePdpImageMutation = <
  TError = CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreatePdpImageMutation, TError, CreatePdpImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreatePdpImageMutation, TError, CreatePdpImageMutationVariables, TContext>({
    mutationKey: ['CreatePdpImage'],
    mutationFn: async ({ portfolio_id, pdp_id, ...body }: CreatePdpImageMutationVariables) => {
      const { data } = await createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost({
        path: { portfolio_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreatePdpImageMutation.fetcher = (
  { portfolio_id, pdp_id, ...body }: CreatePdpImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost({
      path: { portfolio_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
